export const isInStandaloneMode = () =>
    typeof window !== 'undefined'
        ? window.matchMedia('(display-mode: standalone)').matches ||
          (window.navigator as Navigator & { standalone: boolean }).standalone ||
          document.referrer.includes('android-app://')
        : false;
